var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-get-lastest-products w-200" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-primary pd-l-35 pd-r-35 bd-rds-5 w-165",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.getLatestProducts()
          }
        }
      },
      [_vm._v("最新情報取得")]
    ),
    _vm._v(" "),
    _vm.reportCreationDate
      ? _c("div", { staticClass: "product-bubble-wrapper" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBubble,
                  expression: "showBubble"
                }
              ],
              staticClass: "product-bubble get-lastest-bubble",
              on: {
                mouseover: function($event) {
                  _vm.handleMouseOver()
                },
                mouseleave: function($event) {
                  _vm.handleMouseLeave()
                }
              }
            },
            [
              _c("div", [
                _c("strong", [_vm._v(_vm._s(_vm.reportCreationDate))]),
                _vm._v(" 時点の情報を表示しています。")
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "注）最新情報を取得した場合でも最大で2時間前のデータを取得することがあります。"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-info-circle get-lastest-bubble-icon",
            on: {
              mouseover: function($event) {
                _vm.handleMouseOver()
              },
              mouseleave: function($event) {
                _vm.handleMouseLeave()
              }
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70ff8a13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ff8a13","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetLatestProductsButton.vue
// module id = null
// module chunks = 